/**
 * The LA Mirage mobile app's store identity — one place for lamirage.co and la-mirage.in
 * (spec docs/superpowers/specs/2026-10-07-lamirage-co-landing-app-launch-design.md).
 *
 * APP_STORES_LIVE gates every badge, store link, smart banner and MobileApplication JSON-LD.
 * Apple's badge guidelines forbid the App Store badge before the app is available, so while
 * false the sites show only a "Coming soon to iPhone & Android" pill. Flip it (one commit +
 * deploy-both.sh) once BOTH stores list the app publicly.
 */
export const APP_STORES_LIVE = false;

export const APP_IOS_ID = "6817849739";
export const APP_ANDROID_PACKAGE = "in.lamirage.app";
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_IOS_ID}`;
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${APP_ANDROID_PACKAGE}`;

/** Owner chose "India's first" (2026-10-07); always shown with APP_FIRST_QUALIFIER nearby. */
export const APP_FIRST_CLAIM = "India's first wedding venue with its own app";
export const APP_FIRST_QUALIFIER = "as far as we know";
export const APP_COMING_SOON = "Coming soon to iPhone & Android";
